import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";
import useUserPermission from "~/hooks/useUserPermission";

export const useDatasetAssistantV2 = (): boolean => {
  const user = useUser();
  const fliptEnabled = useFliptBoolean("dataset-agui-agent", false, user?.email);
  const hasUseAiAgentsPermission = useUserPermission("use:ai-agents");
  return fliptEnabled && hasUseAiAgentsPermission;
};

export default useDatasetAssistantV2;
